import type { ComponentType, SVGProps } from 'react';
import { LogoPichlmeier, LogoPlaceholder } from '@/components/logos';
import type { UiLogoVariant } from './UiLogo.types';

// The wordmark is the only mark this brand has: it appears in the header, in
// the off-canvas menu and in the footer, sized through `--site-logo-height`.
export const LOGO_COMPONENTS: Record<UiLogoVariant, ComponentType<SVGProps<SVGSVGElement>>> = {
    emblem: LogoPichlmeier,
    wordmark: LogoPichlmeier,
    full: LogoPichlmeier,
    footer: LogoPichlmeier,
    menuBackground: LogoPlaceholder,
};
